import m from "../../geodata/es2015/sudanHigh";
window.am4geodata_sudanHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/sudanHigh.js
// module id = null
// module chunks = 